import {
  ATTRIBUTE_BRAND,
  ATTRIBUTE_PRODUCT_TYPE,
  ATTRIBUTE_DESCRIPTION,
  ATTRIBUTE_PICTURE,
  ATTRIBUTE_PRICE,
  VARIANT_ATTRIBUTE_ITEM_COST,
  ATTRIBUTE_TAGS,
  ATTRIBUTE_TITLE,
  ATTRIBUTE_INVENTORY,
  VARIANT_ATTRIBUTE_SKU,
  VARIANT_ATTRIBUTE_WEIGHT,
  VARIANT_ATTRIBUTE_BARCODE,
  VARIANT_ATTRIBUTE_TAXABLE, ATTRIBUTE_PRODUCT_STATUS, ATTRIBUTE_PRODUCT_CATEGORY, VARIANT_ATTRIBUTE_INVENTORY_LOCATION
} from "./attributeTypes.js";

export const attributeOptions = [
  { label: "Title", value: ATTRIBUTE_TITLE },
  { label: "Description", value: ATTRIBUTE_DESCRIPTION },
  { label: "Brand", value: ATTRIBUTE_BRAND },
  { label: "Product type", value: ATTRIBUTE_PRODUCT_TYPE },
  { label: "Product status", value: ATTRIBUTE_PRODUCT_STATUS },
  { label: "Product category", value: ATTRIBUTE_PRODUCT_CATEGORY },
  { label: "Price", value: ATTRIBUTE_PRICE },
  { label: "Cost of item", value: VARIANT_ATTRIBUTE_ITEM_COST },
  { label: "Picture", value: ATTRIBUTE_PICTURE },
  { label: "Inventory", value: ATTRIBUTE_INVENTORY },
  { label: "Inventory location", value: VARIANT_ATTRIBUTE_INVENTORY_LOCATION },
  { label: "Tags", value: ATTRIBUTE_TAGS },
  { label: "SKU", value: VARIANT_ATTRIBUTE_SKU },
  { label: "Barcode", value: VARIANT_ATTRIBUTE_BARCODE },
  { label: "Weight", value: VARIANT_ATTRIBUTE_WEIGHT },
  { label: "Taxable", value: VARIANT_ATTRIBUTE_TAXABLE },
];
